var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baground"},[(_vm.name.startsWith('http'))?_c('img',{staticClass:"logo",attrs:{"src":_vm.name}}):_c('h1',{staticClass:"logo"},[_vm._v(_vm._s(_vm.name))]),(_vm.errorMsg)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }